(function () {
  function compact(value) {
    return typeof value === 'string' ? value.trim() : value;
  }

  function analyticsAllowed() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch (error) {
      return false;
    }
  }

  function track(eventName, detail) {
    if (!eventName) return;

    var payload = Object.assign(
      {
        event: eventName,
        page_path: window.location.pathname
      },
      detail || {}
    );

    if (analyticsAllowed()) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }

    document.dispatchEvent(
      new CustomEvent('diggn:track', {
        detail: payload
      })
    );
  }

  function datasetDetail(element) {
    return {
      label: compact(element.getAttribute('data-diggn-label') || element.textContent),
      location: compact(element.getAttribute('data-diggn-location')),
      url: compact(element.getAttribute('href') || element.getAttribute('data-product-url')),
      product: compact(element.getAttribute('data-diggn-product')),
      collection: compact(element.getAttribute('data-diggn-collection'))
    };
  }

  document.addEventListener(
    'click',
    function (event) {
      var tracked = event.target.closest('[data-diggn-event]');
      if (tracked) {
        var directEvent = tracked.getAttribute('data-diggn-event');
        var directDetail = datasetDetail(tracked);
        track(directEvent, directDetail);
        if (
          directEvent !== 'quiz_start_click' &&
          directDetail.url &&
          (directDetail.url.indexOf('/pages/beard-quiz') !== -1 || directDetail.url.indexOf('/pages/quiz') !== -1)
        ) {
          track('quiz_start_click', directDetail);
        }
        return;
      }

      var link = event.target.closest('a, button');
      if (!link) return;

      var href = link.getAttribute('href') || link.getAttribute('data-product-url') || '';
      var label = compact(link.textContent);

      if (href.indexOf('/pages/beard-quiz') !== -1 || href.indexOf('/pages/quiz') !== -1) {
        track('quiz_start_click', {
          label: label,
          location: 'homepage',
          url: href
        });
        return;
      }

      if (link.closest('.eid-home-offer')) {
        track('seasonal_offer_click', {
          label: label,
          location: 'eid_home_offer',
          url: href
        });
        return;
      }

      if (link.closest('.quick-add')) {
        track('quick_add_click', {
          label: label,
          location: 'product_card',
          url: href
        });
      }
    },
    { passive: true }
  );
})();
